import React from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from '@mui/material';
import {
  renderInputFieldWithoutLabel,
  renderInputFieldWithTextBox,
} from '../../../common/inputField';
import { useDispatch, useSelector } from 'react-redux';
import { setPatientData } from '../../../actions';
import DateComponent from '../../Registrationform/components/dateComponent';
import dayjs from 'dayjs';

const TreatmentHistory = () => {
  const dispatch = useDispatch();
  const patientData = useSelector((state) => state.clinicalReducer);

  const handleTreatmentHistoryChange = (e, treatmentType, field) => {
    const { value } = e.target;
    const updatedTreatmentHistory = {
      ...patientData.patientHistory.treatmentHistory,
      [treatmentType]: {
        ...patientData.patientHistory.treatmentHistory[treatmentType],
        [field]: value,
      },
    };
    dispatch(
      setPatientData(
        'patientHistory.treatmentHistory',
        updatedTreatmentHistory,
      ),
    );
  };

  const handleDateChange = (date, dateString, treatmentType) => {
    const updatedTreatmentHistory = {
      ...patientData.patientHistory.treatmentHistory,
      [treatmentType]: {
        ...patientData.patientHistory.treatmentHistory[treatmentType],
        date: dateString,
      },
    };
    dispatch(
      setPatientData(
        'patientHistory.treatmentHistory',
        updatedTreatmentHistory,
      ),
    );
  };

  const renderTreatmentRow = (treatmentType, treatmentData) => (
    <TableRow key={treatmentType}>
      <TableCell>
        {treatmentData.name === 'IVF' ? 'IVF/ICSI' : treatmentData.name}
      </TableCell>
      <TableCell>
        {renderInputFieldWithoutLabel(
          'No of Attempts',
          treatmentData.noOfAttempts,
          (e) => handleTreatmentHistoryChange(e, treatmentType, 'noOfAttempts'),
        )}
      </TableCell>
      <TableCell>
        <DateComponent
          selectedDate={treatmentData.date ? dayjs(treatmentData.date) : null}
          handleDateChange={(date, dateString) =>
            handleDateChange(date, dateString, treatmentType)
          }
        />
      </TableCell>
      <TableCell>
        {renderInputFieldWithTextBox('Comments', treatmentData.comments, (e) =>
          handleTreatmentHistoryChange(e, treatmentType, 'comments'),
        )}
      </TableCell>
    </TableRow>
  );

  return (
    <React.Fragment>
      <p className="lead">TREATMENT HISTORY:</p>
      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Treatment Name</TableCell>
              <TableCell>No of Attempts</TableCell>
              <TableCell>Date</TableCell>
              <TableCell>Comments</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {Object.entries(patientData.patientHistory.treatmentHistory).map(
              ([treatmentType, treatmentData]) =>
                renderTreatmentRow(treatmentType, treatmentData),
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </React.Fragment>
  );
};

export default TreatmentHistory;
